import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { interval, Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class WebBrowserTabBlinkerService {
    /**
     * Souscription aux événements émis toutes les secondes.
     */
    private subscription: Subscription;

    /**
     * Titre original de l'onglet.
     */
    private originalTitle: string;

    /**
     * Constructeur.
     * @param title : Service permettant de modifier le titre de l'onlet du navigateur.
     */
    constructor(private title: Title) {}

    /**
     * Fait clignoter l'onglet en changeant de titre.
     * @param msg : message à afficher.
     * @param originalTitle : titre original de l'onglet
     */
    blink(msg: string, originalTitle: string): void {
        const newTitle = this.title.getTitle() === originalTitle ? msg : originalTitle;

        this.title.setTitle(newTitle);
    }

    /**
     * Déclenche le clignotement de l'onglet.
     */
    public start() {
        this.originalTitle = this.title.getTitle();
        this.subscription = interval(1000).subscribe((x) => {
            this.blink('session expirée', this.originalTitle);
        });
    }

    /**
     * Arrête le clignotement de l'onglet.
     */
    public stop() {
        if (this.subscription) {
            this.title.setTitle(this.originalTitle);
            this.subscription.unsubscribe();
            this.subscription = null;
        }
    }
}
